import React from 'react'
import {
  RiFacebookCircleFill,
  RiInstagramFill,
  RiLinkedinBoxFill,
} from '@remixicon/react'

import classes from './RightsFooter.module.css'

interface SocialLink {
  url: string
  platform: string
}

interface RightsFooterProps {
  rights: {
    links: {
      url: string
      label: string
    }[]
    copyright: string
  }
  socialLinks: SocialLink[]
}

export const RightsFooter: React.FC<RightsFooterProps> = ({
  rights,
  socialLinks,
}) => {
  const iconMap: Record<string, React.ReactNode> = {
    LinkedIn: <RiLinkedinBoxFill className={classes.socialIcon} />,
    Facebook: <RiFacebookCircleFill className={classes.socialIcon} />,
    Instagram: <RiInstagramFill className={classes.socialIcon} />,
  }

  return (
    <div className={classes.footer}>
      <div className={classes.content}>
        {/* LEFT SIDE */}
        <div className={classes.left}>
          <span>{rights?.copyright}</span>

          {rights?.links?.map((link, index) => (
            <a key={index} href={link.url} className={classes.link}>
              {link.label}
            </a>
          ))}
        </div>

        {/* RIGHT SIDE ICONS */}
        <div className={classes.social}>
          {socialLinks?.map((item, index) => {
            const Icon = iconMap[item.platform]
            if (!Icon) return null

            return (
              <a key={index} href={item.url} target='_blank' rel='noreferrer' aria-label={item.platform}>
                {Icon}
              </a>
            )
          })}
        </div>
      </div>
    </div>
  )
}
